import React, { useMemo } from "react";
import { Box, Paper, Stack, TableContainer } from "@mui/material";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import CardHeaderTitle from "../../components/card-header-title/index.jsx";
// import IncreaseDecreaseArrows from "../../components/increase-decrease-arrows/index.js";
import { toggleButtonStyle } from "../../consts.js"; // Adjust path if needed
import TableLoader from "../../components/table/table-loader.jsx";
import TableHeader from "../../components/table/header.js";
import { getComparatorSort } from "../../helpers/index.js";

const AgentAnalytics = ({ loading, colours, themeMode, listOfAgents }) => {
    const [pickedAgentTOP, setPickedAgentTOP] = React.useState(true);

    const columns = [{
        label: "Agent",
        key: "agent",
        sortable: false,
        style: { minWidth: 150 },
        renderItem: (row, index) => (<>{index + 1 + ". " + row.agent}</>)
    }, {
        //     label: "Move",
        //     key: "move",
        //     sortable: false,
        //     renderItem: (row) => (<IncreaseDecreaseArrows increase={true} percentage="+2" percentageColor={colours.black} percentageFontWeight="normal" />)
        // }, {
        label: "Avg. Vocalysd Score",
        key: "VS",
        sortable: false,
        align: "right",
        renderItem: (row) => (<>{row.VS.toFixed(0)}</>)
    }];

    const list = useMemo(() => {
        if (loading) return [];
        return listOfAgents.sort(getComparatorSort(pickedAgentTOP ? 'desc' : 'asc', 'VS'));
    }, [pickedAgentTOP, loading, listOfAgents]);

    return (
        <Paper
            sx={{ display: "flex", flexDirection: "column", width: '100%', borderRadius: 2.5, padding: 3, boxSizing: "border-box" }}
        >
            {/* Heading and ButtonGroup */}
            <Stack
                direction="row"
                flexWrap="wrap"
                gap={.5}
                justifyContent="space-between"
                alignItems="center"
            >
                <CardHeaderTitle
                    title="Agent Analytics"
                    tooltip="Shows the top performing and bottom performing Agents."
                // viewDetailTitle="View Details"
                // viewDetailAction={() => console.log("Navigate to agent analytics")}
                />
                <ButtonGroup
                    variant="contained"
                    aria-label="outlined primary button group"
                    className="buttons-border-extend"
                >
                    <Button
                        onClick={() => setPickedAgentTOP(true)}
                        style={toggleButtonStyle(pickedAgentTOP, colours, themeMode)}
                    >
                        Top Performers
                    </Button>
                    <Button
                        onClick={() => setPickedAgentTOP(false)}
                        style={toggleButtonStyle(!pickedAgentTOP, colours, themeMode)}
                    >
                        Bottom Performers
                    </Button>
                </ButtonGroup>
            </Stack>

            {/* Table to Display List of Agents */}
            <Box marginTop={.5}>
                <TableContainer>
                    <Table size="small" aria-label="Top Performers Table">
                        <TableHeader columns={columns} />
                        <TableBody>
                            {loading ? (
                                <TableLoader columnsLength={3} />
                            ) : (list.slice(0, 7).map((z, zi) => (
                                <TableRow hover key={zi} >
                                    {columns.map((c, indexColumn) => (
                                        <TableCell key={zi + "-" + indexColumn} align={c.align} sx={{
                                            paddingTop: "3px", paddingBottom: "3px"
                                        }}>
                                            {c.renderItem(z, zi, indexColumn)}
                                        </TableCell>
                                    ))}
                                </TableRow>))
                            )}
                            {!loading && !list?.length ? (
                                <TableRow>
                                    <TableCell colSpan={3}>
                                        No Data Available
                                    </TableCell>
                                </TableRow>
                            ) : ("")}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Paper>
    );
};

export default AgentAnalytics;